import { Modal, Box, IconButton, Typography, OutlinedInput } from "@mui/material";
import { Close, Link, Email } from "@mui/icons-material";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import { useState } from "react";

type ShareModalProps = {
    open: boolean;
    onClose: () => void;
    shareUrl: string;
    shareText: string;
};

const ShareModal = ({ open, onClose, shareUrl, shareText }: ShareModalProps) => {
    const [copied, setCopied] = useState(false);

    const handleWhatsAppShare = () => {
        window.open(
            `https://wa.me/?text=${encodeURIComponent(shareText + ' ' + shareUrl)}`,
            "Share",
            "width=600,height=400"
        )?.focus();
    };

    const handleEmailShare = () => {
        window.open(
            `mailto:?subject=${encodeURIComponent(shareText)}&body=${encodeURIComponent(shareUrl)}`,
            "Share",
            "width=600,height=400"
        )?.focus();
    };

    const handleInstagramShare = () => {
        // Instagram doesn't have a direct share URL, so we'll just copy the link
        navigator.clipboard.writeText(shareUrl).then(() => {
            alert("Link copied! You can now paste it in your Instagram story or post.");
        });
    };

    const handleTwitterShare = () => {
        window.open(
            `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`,
            "Share",
            "width=600,height=400"
        )?.focus();
    };

    const handleCopyLink = () => {
        navigator.clipboard.writeText(shareUrl).then(() => setCopied(true));
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    p: 12,
                    backgroundColor: "white",
                    borderRadius: 2,
                    maxWidth: 400,
                    width: "90%",
                    height: "auto",
                    margin: "auto",
                    mt: "20%",
                    boxShadow: 24,
                    position: "relative",
                    textAlign: "center",
                }}
            >
                <Box display={"flex"} justifyContent={"space-between"} pb={16}>
                    <Typography
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '22px',
                            fontWeight: 600,
                        }}
                    >
                        Share
                    </Typography>
                    <IconButton
                        onClick={onClose}
                    >
                        <Close />
                    </IconButton>
                </Box>
                {/* Social Media Share Icons */}
                <Box display="flex" justifyContent="space-around" pb={16}>
                    <Box display="flex" flexDirection="column" gap={4} alignItems="center" sx={{ width: "50px" }}>
                        <IconButton onClick={handleTwitterShare} sx={{ background: "#f5f5f5", "&:hover": { background: "#cccccc", } }}>
                            <XIcon />
                        </IconButton>
                        <Typography sx={{
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '14px',
                            fontWeight: 500,
                        }}>Twitter</Typography>
                    </Box>
                    <Box display="flex" flexDirection="column" gap={4} alignItems="center" sx={{ width: "50px" }}>
                        <IconButton onClick={handleWhatsAppShare} sx={{ background: "#f5f5f5", "&:hover": { background: "#cccccc", } }}>
                            <WhatsAppIcon />
                        </IconButton>
                        <Typography sx={{
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '14px',
                            fontWeight: 500,
                        }}>WhatsApp</Typography>
                    </Box>
                    <Box display="flex" flexDirection="column" gap={4} alignItems="center" sx={{ width: "50px" }}>
                        <IconButton onClick={handleEmailShare} sx={{ background: "#f5f5f5", "&:hover": { background: "#cccccc", } }}>
                            <Email />
                        </IconButton>
                        <Typography sx={{
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '14px',
                            fontWeight: 500,
                        }}>Email</Typography>
                    </Box>
                    <Box display="flex" flexDirection="column" gap={4} alignItems="center" sx={{ width: "50px" }}>
                        <IconButton onClick={handleInstagramShare} sx={{ background: "#f5f5f5", "&:hover": { background: "#cccccc", } }}>
                            <InstagramIcon />
                        </IconButton>
                        <Typography sx={{
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '14px',
                            fontWeight: 500,
                        }}>Instagram</Typography>
                    </Box>
                </Box>

                <Typography pb={4} display={"flex"} justifyContent={"start"}
                    sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontSize: '16px',
                        fontWeight: 600,

                    }}
                >Land Link</Typography>
                {/* Page Link with Copy Button */}
                <Box display="flex" alignItems="end" justifyContent="end">
                    <OutlinedInput
                        value={shareUrl}
                        fullWidth
                        sx={{
                            borderRadius: 0.5,
                            backgroundColor: "#f8f9fb",
                            '& .MuiOutlinedInput-notchedOutline': {
                                border: 'none'
                            },
                        }}
                        endAdornment={
                            <IconButton onClick={handleCopyLink}>
                                <Link />
                            </IconButton>
                        }
                        size="small"
                    />

                </Box>
                {copied && <Typography variant="caption" color="light.border.default">Copied!</Typography>}
            </Box>
        </Modal>
    );
};

export default ShareModal;
